export default function NexaLogo({ size = 32, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Theme-color background */}
      <rect width="40" height="40" rx="9" fill="#4F46E5"/>

      {/* Antenna stem + tip */}
      <rect x="19" y="5" width="2.5" height="7" rx="1.25" fill="white"/>
      <circle cx="20" cy="4.5" r="2" fill="white"/>

      {/* Robot head — slightly smaller for more padding */}
      <rect x="9" y="13" width="22" height="18" rx="5" fill="white"/>

      {/* Ear ports */}
      <rect x="5.5" y="20" width="4" height="4.5" rx="2" fill="white"/>
      <rect x="30.5" y="20" width="4" height="4.5" rx="2" fill="white"/>

      {/* Eyes — horizontal LED bars */}
      <rect x="11" y="18.5" width="6.5" height="4" rx="1.75" fill="#4F46E5"/>
      <rect x="22.5" y="18.5" width="6.5" height="4" rx="1.75" fill="#4F46E5"/>
      {/* Eye glint highlights */}
      <rect x="12" y="19.5" width="2.5" height="1.8" rx="0.9" fill="white" fillOpacity="0.55"/>
      <rect x="23.5" y="19.5" width="2.5" height="1.8" rx="0.9" fill="white" fillOpacity="0.55"/>

      {/* Mouth */}
      <rect x="14.5" y="26.5" width="11" height="2" rx="1" fill="#4F46E5" fillOpacity="0.3"/>
    </svg>
  );
}
